import * as yup from 'yup';

const webhookSchema = yup.object().shape({
  payload_url: yup.string().required('Required field'),
  content_type: yup.string().required('Required field'),
  event_type: yup.string().required('Required field'),
  secret: yup.string(),
  builder_id: yup.number().when('$isEnterprise', {
    is: true,
    then: yup.number().nullable().required('Builder is required'),
    otherwise: yup.number().notRequired(),
  }),
});

export default webhookSchema;
